/* ============================================================================
   SG-2026 · Zentrale Ertrags-/Ersparnis-Logik
   ----------------------------------------------------------------------------
   Einzige Rechenlogik für Statbar (sg-image-stats.liquid), Ertragsrechner
   (sg-2026-calculator.liquid) und Produkt-Konfiguratoren. Keine Formel darf
   außerhalb dieser Datei dupliziert werden - andere Komponenten lesen nur
   window.SGErtrag.berechne(...) aus und rendern das Ergebnis.

   Ausnahme (bewusst, technisch bedingt): Die Statbar muss ihre Erstanzeige
   serverseitig in Liquid ausliefern (SEO/No-JS/kein Flash), siehe
   snippets/sg-image-stats.liquid. Dort ist das Autarkie-Modell dieser Datei
   in Liquid-Mathe nachgebaut - bei Änderungen an SG_KONSTANTEN oder
   HTW_AUTARKIE IMMER auch dort synchron halten (Kommentar an Ort und Stelle).

   Autarkiegrad-Nachschlagetabelle: Unabhängigkeitsrechner der Forschungs-
   gruppe Solarspeichersysteme der HTW Berlin, basierend auf über 25.000
   minütlich simulierten Systemkonfigurationen.

   Datenquelle pro Produkt (Metafields, nur lesend):
     custom.sg_kwp                 kWp des Sets
     custom.sg_speicher_kwh        Basis-Speicherkapazität (0 = ohne Speicher)
     custom.sg_speicher_max_kwh    maximaler Speicherausbau
     custom.sg_speicher_modul_kwh  Kapazität eines Erweiterungsakkus
     custom.sg_notstrom_w          Notstromleistung (kann fehlen)
     custom.sg_netzladen_w         Netzladeleistung (kann fehlen)
   ============================================================================ */

(function (root) {
  'use strict';

  if (root.SGErtrag) return;

  var SG_KONSTANTEN = {
    BASISERTRAG: 950,              // kWh pro kWp und Jahr bei Süd, Deutschland-Mittel (unsere Anzeige)
    AUSRICHTUNG: { sued: 1.00, so_sw: 0.92, ost_west: 0.85, nord: 0.65 },
    VERBRAUCH_REFERENZ: 3500,      // kWh/Jahr, auf die sich HTW_AUTARKIE bezieht
    VERBRAUCH_DEFAULT: 3500,       // kWh pro Jahr
    STROMPREIS_DEFAULT: 0.35,      // EUR pro kWh
    STROMPREIS_STEIGERUNG: 0.025,  // 2,5 % pro Jahr
    HTW_BASISERTRAG: 1024,         // kWh/kWp, Ertragsannahme der HTW-Simulation
    DYN_TARIF_SPREAD: 0.24,        // Preisspanne dynamischer Tarif (Nacht- vs. Abendpreis)
    DYN_TARIF_ZYKLEN: 250,         // nutzbare Vollzyklen pro Jahr
    SPEICHER_WIRKUNGSGRAD: 0.839,  // AC-zu-AC, Quelle HTW Berlin
    SPEICHER_VERFUEGBAR: 0.90,     // mittlere nutzbare Kapazität über die Lebensdauer, HTW Berlin
    EINSPEISE_LIMIT_W: 800,        // Schuko-Standard
    NOTSTROM_GRUNDLAST_W: 300,     // Kühlschrank + Router + Licht, Annahme für Notstrom-Kennzahl
    JAHRE: 10
  };

  // Autarkiegrad in % nach HTW-Unabhängigkeitsrechner.
  // Zeilen = Speicherkapazität in kWh, Spalten = Anlagenleistung in kWp.
  //
  // Quelle: tabelleAutarkie.json des HTW-Unabhaengigkeitsrechners
  // (solar.htw-berlin.de/unabhaengigkeitsrechner), an den Stuetzstellen
  // unten ausgewertet und auf VERBRAUCH_REFERENZ = 3.500 kWh/a normiert.
  // Keine geschaetzten Werte mehr - die frueheren drei "ergaenzt"-Zellen
  // sind durch die echten Werte ersetzt (4 kWp/2,7 kWh: 52 -> 53,
  // 6 kWp/2,7 kWh: 55 -> 57, 3 kWp/5,0 kWh: 57 -> 59).
  //
  // Die Zeilen reichen bis 30 kWh, weil die Solarbank 4 Pro dort hin
  // ausgebaut werden kann. Vorher endete die Tabelle bei 5,0 kWh - da die
  // Solarbank schon mit 5,024 kWh startet, wurde jede Speichererweiterung
  // auf den Randwert geclamped und aenderte Ertrag und Ersparnis um exakt 0.
  var HTW_AUTARKIE = {
    0.0:  { 1: 18, 2: 25, 3: 29, 4: 32, 6: 35, 8: 37, 10: 38 },
    2.7:  { 1: 27, 2: 43, 3: 49, 4: 53, 6: 57, 8: 59, 10: 61 },
    5.0:  { 1: 27, 2: 49, 3: 59, 4: 64, 6: 69, 8: 72, 10: 74 },
    7.5:  { 1: 27, 2: 51, 3: 63, 4: 69, 6: 75, 8: 79, 10: 81 },
    10.0: { 1: 27, 2: 52, 3: 65, 4: 70, 6: 77, 8: 81, 10: 83 },
    15.0: { 1: 27, 2: 53, 3: 66, 4: 72, 6: 79, 8: 83, 10: 86 },
    20.0: { 1: 27, 2: 53, 3: 66, 4: 73, 6: 80, 8: 84, 10: 87 },
    30.0: { 1: 27, 2: 53, 3: 67, 4: 74, 6: 81, 8: 85, 10: 89 }
  };
  var HTW_SPEICHER_KEYS = [0.0, 2.7, 5.0, 7.5, 10.0, 15.0, 20.0, 30.0];
  var HTW_KWP_KEYS = [1, 2, 3, 4, 6, 8, 10];

  // Ohne Speicher: Anteil des DC-Ertrags, der am Einspeiselimit tatsächlich
  // nutzbar ankommt. Schlüssel = (kWp * 1000) / Einspeiselimit in W.
  // TODO: gegen PVGIS mit Wechselrichterlimit validieren.
  var KAPPUNG_OHNE_SPEICHER_PUNKTE = [
    { ratio: 1.0, faktor: 1.00 },
    { ratio: 1.25, faktor: 0.98 },
    { ratio: 1.5, faktor: 0.96 },
    { ratio: 2.0, faktor: 0.93 },
    { ratio: 2.5, faktor: 0.90 },
    { ratio: 3.0, faktor: 0.88 }
  ];

  // Mit Speicher: Anteil der Autarkie/des Ertrags, der trotz begrenzter
  // Entladeleistung des Speichers tatsächlich ankommt. Mit 800 W kann der
  // Speicher abends Lastspitzen (Backofen, Herd, Wasserkocher) nicht decken,
  // die trotz vollem Akku aus dem Netz kommen; mit 2.500 W (Wieland) entfällt
  // das. Schlüssel = Einspeiselimit in W. Bewusst konservativ: die Schuko-
  // Variante wird abgewertet, nicht die Wieland-Variante aufgewertet.
  // TODO: gegen Lastprofil validieren.
  var ENTLADE_ABSCHLAG_PUNKTE = [
    { limitW: 800, faktor: 0.94 },
    { limitW: 1200, faktor: 0.97 },
    { limitW: 2500, faktor: 1.00 }
  ];

  function num(v, fallback) {
    var n = typeof v === 'number' ? v : parseFloat(v);
    return isNaN(n) ? fallback : n;
  }

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  /** Lineare Interpolation zwischen benachbarten Stützstellen einer sortierten Punkteliste. */
  function interpoliereLinear(punkte, xKey, yKey, x) {
    if (x <= punkte[0][xKey]) return punkte[0][yKey];
    var last = punkte[punkte.length - 1];
    if (x >= last[xKey]) return last[yKey];
    for (var i = 0; i < punkte.length - 1; i++) {
      var a = punkte[i], b = punkte[i + 1];
      if (x >= a[xKey] && x <= b[xKey]) {
        var t = (x - a[xKey]) / (b[xKey] - a[xKey]);
        return a[yKey] + t * (b[yKey] - a[yKey]);
      }
    }
    return last[yKey];
  }

  /**
   * Ohne Speicher: Anteil des DC-Ertrags, der am Wechselrichter-/Einspeiselimit
   * tatsächlich nutzbar ankommt. Mit Speicher wird das nicht gebraucht (siehe
   * ENTLADE_ABSCHLAG) - diese Funktion wird nur für hatSpeicher === false gerufen.
   */
  function kappungsFaktorOhneSpeicher(kwp, limitW) {
    kwp = num(kwp, 0);
    limitW = num(limitW, SG_KONSTANTEN.EINSPEISE_LIMIT_W);
    if (kwp <= 0 || limitW <= 0) return 1.0;

    var ratio = (kwp * 1000) / limitW;
    var punkte = KAPPUNG_OHNE_SPEICHER_PUNKTE.map(function (p) { return { x: p.ratio, y: p.faktor }; });
    var faktor = interpoliereLinear(punkte, 'x', 'y', ratio);

    if (faktor < 0.95 && root.console && root.console.info) {
      root.console.info(
        '[SGErtrag] Kappungsfaktor ohne Speicher: ' + faktor.toFixed(2) + ' bei kwp=' + kwp +
        ', limitW=' + limitW + ' (DC/AC ' + ratio.toFixed(2) + ':1).'
      );
    }

    return faktor;
  }

  /**
   * Mit Speicher: Abschlag auf Autarkie/Ertrag durch die begrenzte Entladeleistung
   * des Speichers, abhängig vom Einspeiselimit (Schuko 800 W vs. Wieland 2.500 W).
   */
  function entladeAbschlag(limitW) {
    limitW = num(limitW, SG_KONSTANTEN.EINSPEISE_LIMIT_W);
    var punkte = ENTLADE_ABSCHLAG_PUNKTE.map(function (p) { return { x: p.limitW, y: p.faktor }; });
    return interpoliereLinear(punkte, 'x', 'y', limitW);
  }

  /**
   * Bilineare Interpolation der HTW-Autarkietabelle für beliebige (speicherEff, kwpEff).
   * Speicher-Achse: unter/über den Stützstellen wird der Randwert gehalten (0 kWh
   * Speicher ist ohnehin die unterste Stützstelle, mehr als 5 kWh_eff ist am oberen
   * Rand real kaum relevant). kWp-Achse: am oberen Rand (>6) wird ebenfalls der
   * Randwert gehalten, aber UNTER der kleinsten Stützstelle (1 kWp) linear gegen
   * 0 skaliert - 0 kWp muss 0 % Autarkie ergeben, sonst würden 900-/1000-W-Sets
   * systematisch zu hohe Werte bekommen (Randwert statt echter Extrapolation).
   */
  function htwAutarkiePct(speicherEff, kwpEff) {
    var kwpMin = HTW_KWP_KEYS[0];
    var kwpMax = HTW_KWP_KEYS[HTW_KWP_KEYS.length - 1];
    speicherEff = clamp(speicherEff, HTW_SPEICHER_KEYS[0], HTW_SPEICHER_KEYS[HTW_SPEICHER_KEYS.length - 1]);

    var sLo = HTW_SPEICHER_KEYS[0], sHi = HTW_SPEICHER_KEYS[HTW_SPEICHER_KEYS.length - 1];
    for (var i = 0; i < HTW_SPEICHER_KEYS.length - 1; i++) {
      if (speicherEff >= HTW_SPEICHER_KEYS[i] && speicherEff <= HTW_SPEICHER_KEYS[i + 1]) {
        sLo = HTW_SPEICHER_KEYS[i]; sHi = HTW_SPEICHER_KEYS[i + 1];
        break;
      }
    }
    var sT = sHi === sLo ? 0 : (speicherEff - sLo) / (sHi - sLo);
    var rowLo = HTW_AUTARKIE[sLo], rowHi = HTW_AUTARKIE[sHi];

    var vLo, vHi;
    if (kwpEff < kwpMin) {
      var scale = Math.max(kwpEff, 0) / kwpMin;
      vLo = rowLo[kwpMin] * scale;
      vHi = rowHi[kwpMin] * scale;
    } else {
      var kwpEffClamped = Math.min(kwpEff, kwpMax);
      var kLo = HTW_KWP_KEYS[0], kHi = HTW_KWP_KEYS[HTW_KWP_KEYS.length - 1];
      for (var j = 0; j < HTW_KWP_KEYS.length - 1; j++) {
        if (kwpEffClamped >= HTW_KWP_KEYS[j] && kwpEffClamped <= HTW_KWP_KEYS[j + 1]) {
          kLo = HTW_KWP_KEYS[j]; kHi = HTW_KWP_KEYS[j + 1];
          break;
        }
      }
      var kT = kHi === kLo ? 0 : (kwpEffClamped - kLo) / (kHi - kLo);
      vLo = rowLo[kLo] + (rowLo[kHi] - rowLo[kLo]) * kT; // Autarkie bei sLo, interpoliert über kWp
      vHi = rowHi[kLo] + (rowHi[kHi] - rowHi[kLo]) * kT; // Autarkie bei sHi, interpoliert über kWp
    }

    return vLo + (vHi - vLo) * sT; // über Speicher interpoliert
  }

  /**
   * Kernfunktion. input:
   *   kwp, speicherKwh, speicherModulKwh (Schrittgröße einer Erweiterungsstufe,
   *   für den speicherLimitiert-Test), ausrichtung, verbrauch, strompreis,
   *   einspeiseLimitW
   */
  function berechne(input) {
    input = input || {};

    var kwp = num(input.kwp, 0);
    var speicherKwh = num(input.speicherKwh, 0);
    var speicherModulKwh = num(input.speicherModulKwh, 0);
    var ausrichtungsfaktor = SG_KONSTANTEN.AUSRICHTUNG[input.ausrichtung];
    if (ausrichtungsfaktor == null) ausrichtungsfaktor = SG_KONSTANTEN.AUSRICHTUNG.sued;
    var verbrauch = num(input.verbrauch, SG_KONSTANTEN.VERBRAUCH_DEFAULT);
    var strompreis = num(input.strompreis, SG_KONSTANTEN.STROMPREIS_DEFAULT);
    var einspeiseLimitW = num(input.einspeiseLimitW, SG_KONSTANTEN.EINSPEISE_LIMIT_W);
    var hatSpeicher = speicherKwh > 0;

    var verbrauchsFaktor = verbrauch > 0 ? (SG_KONSTANTEN.VERBRAUCH_REFERENZ / verbrauch) : 1;
    var kwpEff = kwp * (SG_KONSTANTEN.BASISERTRAG / SG_KONSTANTEN.HTW_BASISERTRAG) * verbrauchsFaktor * ausrichtungsfaktor;
    var speicherEff = speicherKwh * verbrauchsFaktor;

    // Bruttoertrag (DC) - unsere eigene, konservativere Ertragsannahme (950 statt 1.024 kWh/kWp)
    var ertragDc = kwp * SG_KONSTANTEN.BASISERTRAG * ausrichtungsfaktor;

    // Ohne Speicher wirkt die 800/2.500-VA-Grenze NICHT auf den angezeigten
    // Ertrag - die gekappte Spitzenleistung wäre ohnehin nie zeitgleich zum
    // Verbrauch nutzbar gewesen. Sie wirkt stattdessen unten auf die Autarkie
    // (und damit nur auf die Ersparnis). Der Ertrag bleibt kwp × BASISERTRAG × Ausrichtung.
    // Mit Speicher ist die Entladeleistung dagegen ein echter Verlust am AC-Ausgang,
    // deshalb reduziert entladeAbschlag() hier den Ertrag direkt.
    var kappungOhneSpeicher = kappungsFaktorOhneSpeicher(kwp, einspeiseLimitW);
    var abschlagFaktor = hatSpeicher ? entladeAbschlag(einspeiseLimitW) : kappungOhneSpeicher;
    var ertragAc = hatSpeicher ? ertragDc * abschlagFaktor : ertragDc;

    // Autarkiegrad aus der HTW-Tabelle (roh), normalisiert auf Verbrauch/Ertrag/Ausrichtung.
    // abschlagFaktor wirkt hier IMMER (mit wie ohne Speicher) - das ist der einzige
    // Ort, an dem die Einspeisegrenze die Ersparnis beeinflusst.
    var autarkiePctRoh = htwAutarkiePct(speicherEff, kwpEff);
    var autarkiePct = autarkiePctRoh * abschlagFaktor;
    var autarkie = autarkiePct / 100;
    var genutzt = autarkie * verbrauch;
    var netzbezug = verbrauch - genutzt;

    // Direktverbrauch = (rohe) Autarkie bei gleicher Anlagengröße OHNE Speicher,
    // ebenfalls durch die 800/2.500-VA-Grenze gekappt (das ist die reine
    // Zeitgleichheitsgrenze ohne Batteriepuffer). Die Differenz zum tatsächlichen
    // Wert ist die Batterieentladung.
    var autarkieOhnePct = htwAutarkiePct(0, kwpEff);
    var direkt = Math.min((autarkieOhnePct / 100) * kappungOhneSpeicher * verbrauch, genutzt);
    var ausSpeicher = genutzt - direkt;

    var ersparnisJahr = genutzt * strompreis;
    var ersparnisZehnJahre = 0;
    for (var jahr = 0; jahr < SG_KONSTANTEN.JAHRE; jahr++) {
      var preisJahr = strompreis * Math.pow(1 + SG_KONSTANTEN.STROMPREIS_STEIGERUNG, jahr);
      ersparnisZehnJahre += genutzt * preisJahr;
    }

    // Deckel: hebt eine zusätzliche kWp die (rohe) Autarkie um weniger als 1,5
    // Prozentpunkte an? Bewusst auf Basis der rohen Tabellenwerte (roh, nicht
    // durch abschlagFaktor verzerrt) und als Differenz statt Tabellenrand -
    // sonst würde der Deckel bei kleinen Sets (kwpEff < 6) nie greifen, obwohl
    // die Grenznutzen-Kurve dort schon abflacht.
    var autarkiePctPlus1 = htwAutarkiePct(speicherEff, kwpEff + 1);
    var deckelAktiv = (autarkiePctPlus1 - autarkiePctRoh) < 1.5;

    // speicherLimitiert: hebt eine zusätzliche Erweiterungsstufe (+speicherModulKwh)
    // die (rohe) Autarkie um mehr als 1,5 Prozentpunkte an? Nur relevant, wenn es
    // überhaupt eine Erweiterungsstufe gibt.
    var speicherLimitiert = false;
    if (speicherModulKwh > 0) {
      var speicherEffNaechste = (speicherKwh + speicherModulKwh) * verbrauchsFaktor;
      var autarkieNaechstePct = htwAutarkiePct(speicherEffNaechste, kwpEff);
      speicherLimitiert = (autarkieNaechstePct - autarkiePctRoh) > 1.5;
    }

    return {
      ertragDc: ertragDc,
      ertragAc: ertragAc,
      autarkie: autarkie,
      genutzt: genutzt,
      direkt: direkt,
      ausSpeicher: ausSpeicher,
      netzbezug: netzbezug,
      ersparnisJahr: ersparnisJahr,
      ersparnisZehnJahre: ersparnisZehnJahre,
      speicherLimitiert: speicherLimitiert,
      deckelAktiv: deckelAktiv
    };
  }

  /** speicherKwh aus den Bausteinen, die Konfiguratoren im sg:konfiguration-Event liefern. */
  function speicherKwhAus(basisKwh, modulKwh, akkuQty) {
    return num(basisKwh, 0) + num(modulKwh, 0) * num(akkuQty, 0);
  }

  /**
   * Aufpreis-Box, Kennzahl B (Notstrom): nutzbare Stunden bei NOTSTROM_GRUNDLAST_W
   * Dauerlast (Kühlschrank, Router, Licht), auf halbe Stunden gerundet.
   */
  function notstromStunden(speicherKwh) {
    speicherKwh = num(speicherKwh, 0);
    if (speicherKwh <= 0) return 0;
    var grundlastKw = SG_KONSTANTEN.NOTSTROM_GRUNDLAST_W / 1000;
    return rundeAuf((speicherKwh * SG_KONSTANTEN.SPEICHER_VERFUEGBAR) / grundlastKw, 0.5);
  }

  /**
   * Aufpreis-Box, Kennzahl C (dynamischer Tarif): zusätzliche jährliche Ersparnis
   * durch nächtliches Laden aus dem Netz und abendliches Entladen, unabhängig von
   * der Modulleistung (funktioniert auch im Winter).
   */
  function dynTarifErsparnisJahr(speicherKwh) {
    speicherKwh = num(speicherKwh, 0);
    if (speicherKwh <= 0) return 0;
    return speicherKwh * SG_KONSTANTEN.SPEICHER_VERFUEGBAR * SG_KONSTANTEN.DYN_TARIF_ZYKLEN *
      SG_KONSTANTEN.DYN_TARIF_SPREAD * SG_KONSTANTEN.SPEICHER_WIRKUNGSGRAD;
  }

  function rundeAuf(n, schritt) {
    n = num(n, 0);
    schritt = num(schritt, 1) || 1;
    return Math.round(n / schritt) * schritt;
  }

  var fmt = {
    num: function (n, opts) {
      return num(n, 0).toLocaleString('de-DE', opts || { maximumFractionDigits: 0 });
    },
    eur: function (n) {
      return fmt.num(n) + ' \u20ac';
    },
    kwh: function (n) {
      return fmt.num(n) + ' kWh';
    },
    kwp: function (n) {
      return num(n, 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kWp';
    },
    /* Speicherkapazitäten: immer exakt eine Nachkommastelle, gerechnet wird vorher exakt. */
    speicherKwh: function (n) {
      return num(n, 0).toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' kWh';
    },
    kommazahl: function (n, maxDigits) {
      return num(n, 0).toLocaleString('de-DE', { maximumFractionDigits: maxDigits == null ? 2 : maxDigits });
    },
    preis: function (n) {
      return num(n, 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  };

  root.SGErtrag = {
    KONSTANTEN: SG_KONSTANTEN,
    HTW_AUTARKIE: HTW_AUTARKIE,
    KAPPUNG_OHNE_SPEICHER_PUNKTE: KAPPUNG_OHNE_SPEICHER_PUNKTE,
    ENTLADE_ABSCHLAG_PUNKTE: ENTLADE_ABSCHLAG_PUNKTE,
    kappungsFaktorOhneSpeicher: kappungsFaktorOhneSpeicher,
    entladeAbschlag: entladeAbschlag,
    htwAutarkiePct: htwAutarkiePct,
    berechne: berechne,
    speicherKwhAus: speicherKwhAus,
    notstromStunden: notstromStunden,
    dynTarifErsparnisJahr: dynTarifErsparnisJahr,
    rundeAuf: rundeAuf,
    fmt: fmt
  };
})(window);
